import React, { useEffect, useState } from 'react'
import api from '../services/api'

function PerfilNotificaciones({ perfilId }) {
  const [notificaciones, setNotificaciones] = useState([])

  useEffect(() => {
    if (perfilId) {
      api.get(`/notificaciones/${perfilId}`)
        .then(res => setNotificaciones(res.data))
        .catch(err => console.error('Error al cargar notificaciones', err))
    }
  }, [perfilId])

  return (
    <div className="notificaciones">
      <h3>Notificaciones</h3>
      {notificaciones.length === 0 ? (
        <p>No tienes notificaciones nuevas.</p>
      ) : (
        <ul>
          {notificaciones.map((n) => (
            <li key={n.id}>
              <strong>{n.titulo}</strong>
              <p>{n.mensaje}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default PerfilNotificaciones
